import { render, staticRenderFns } from "./RelationsSelectionDialog.vue?vue&type=template&id=c0359c64"
import script from "./RelationsSelectionDialog.vue?vue&type=script&lang=js"
export * from "./RelationsSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports